import { render, staticRenderFns } from "./distributionDetails.vue?vue&type=template&id=ee2705b0&scoped=true"
import script from "./distributionDetails.vue?vue&type=script&lang=js"
export * from "./distributionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2705b0",
  null
  
)

export default component.exports